var AuthService = /** @class */ (function () {
    function AuthService(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Logs user in
     * @param requestBody
     * @returns LoginResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authLogin = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/login',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Logs user out and closes all sessions
     * @param requestBody
     * @returns any OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authLogout = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/logout',
            body: requestBody
        });
    };
    /**
     * Starts one click login routine. User will get email with link that will log him in
     * @param requestBody
     * @returns any OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authOneClickLogin = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/one-click',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Method to call when user arrives to the page and has transient code to exchange for jwt/refresh token
     * @param requestBody
     * @returns OneClickConfirmResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authOneClickConfirm = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/one-click-login',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Check user's email and provides first name if email found
     * @param requestBody
     * @returns PreAuthResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authPreAuth = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/pre-auth',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Creates user account with client scope
     * @param requestBody
     * @returns LoginResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authRegister = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/register',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Gets brand to use for registration, can be unique per auth client id
     * @param requestBody
     * @returns SelectBrandResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authSelectBrand = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/select-brand',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Returns social login url to redirect user to. User later will be redirected to the callback
     * url and redirected back to the caller
     * @param requestBody
     * @returns SocialLoginResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authSocialLoginRedirect = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/social-redirect',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * @param requestBody
     * @returns SocialLoginCallbackResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authSocialLoginCallback = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/social/finalize',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Exchanges supplied short living token or api token to JWT token that is used to make all other calls
     * @param requestBody
     * @returns TokenExchangeResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authTokenExchange = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/token/exchange',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Refreshes JWT token and supplies newer refresh token
     * @param requestBody
     * @returns TokenRefreshResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authRefresh = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/token/refresh',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Validates token and returns user info
     * @param requestBody
     * @returns ValidateIdentityTokenResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authValidateIdentityToken = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/token/validate',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Gets info about currently logged in use. User is taken from jwt token
     * @returns UserInfoResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authUserInfo = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/user-info'
        });
    };
    /**
     * @param requestBody
     * @returns any OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authValidateEmail = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/validate/email',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Validate email address for existance in our db, does not validate email itself
     * @param requestBody
     * @returns any OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authValidateEmailHash = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/validate/email-hash',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Vaklidates password. There are several complexity checks
     * @param requestBody
     * @returns any OK
     * @returns Status Default error response
     * @throws ApiError
     */
    AuthService.prototype.authValidatePassword = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/validate/password',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    return AuthService;
}());
export { AuthService };
//# sourceMappingURL=AuthService.js.map